<template>
  <el-form
    ref="registrationSymbolForm"
    :model="model"
    :rules="rules"
    label-width="10em"
    label-position="left"
    class="registration-symbol-form"
  >
    <template v-if="searchMode">
      <div class="el-form--inline">
        <DateTime v-model="searchBaseDate" prop="ownerCode" label="検索基準日時" :searchCond="searchMode" />
        <Blank />
      </div>
    </template>
    <template v-else-if="editMode">
      <div class="el-form--inline">
        <DateTime v-model="startDate" prop="start_date" label="適用開始日時" :searchCond="searchMode" :disabled="true" />
        <DateTime v-model="endDate" prop="end_date" label="適用終了日時" :searchCond="searchMode" :required="true" limit="to" :limitDate = startDate />
      </div>
    </template>
    <template v-else>
      <DateTimeRange :dateTimeFrom.sync="startDate" :dateTimeTo.sync="endDate" label="適用期間" :required="!searchMode" :searchCond="searchMode" />
      <!-- <DateRange :dateFrom.sync="startDate" :dateTo.sync="endDate" label="適用期間" :required="!searchMode" :searchCond="searchMode" /> -->
    </template>
    <el-divider />
    <div class="el-form--inline">
      <RegistrationSymbol v-model="registrationSymbol" :required="!searchMode" :searchCond="searchMode"
        :disabled="editMode" :autofocus="!editMode" :autocomplete-list="autocompleteRegistrationSymbolSet" />
      <Blank />
    </div>
    <div class="el-form--inline">
      <OwnerCode v-model="ownerCode" :required="!searchMode" :searchCond="searchMode" :autofocus="editMode"
        :autocomplete-list="autocompleteOwnerCodeSet" />
      <ModelCode v-model="modelCode" :required="!searchMode" :searchCond="searchMode"
      :autocomplete-list="autocompleteModelCodeSet" />
    </div>
    <div class="el-form--inline">
      <AircraftType v-model="aircraftType" :required="!searchMode" :searchCond="searchMode" />
      <AircraftAttribute v-model="aircraftAttribute" :required="!searchMode" :searchCond="searchMode" :initialize="true" />
    </div>
    <el-divider />
    <template v-if="searchMode" >
      <div class="el-form--inline">
        <Numeric v-model="weight1" label="重量1[t]" prop="weight_1" :required="!searchMode" :searchCond="searchMode" :min="0.1" :max="999.9" :precision="1" :step="0.1"/>
        <Numeric v-model="noiseLevel1" label="騒音値1[EPNdB]" prop="noise_level_1" :required="!searchMode" :searchCond="searchMode" :min="0" :max="999" :step="1"/>
      </div>
      <div class="el-form--inline">
        <Numeric v-model="weight2" label="重量2[t]" prop="weight_2" :searchCond="searchMode" :min="0.1" :max="999.9" :precision="1" :step="0.1"/>
        <Numeric v-model="noiseLevel2" label="騒音値2[EPNdB]" prop="noise_level_2" :searchCond="searchMode" :min="0" :max="999" :step="1"/>
      </div>
      <div class="el-form--inline">
        <Numeric v-model="weight3" label="重量3[t]" prop="weight_3" :searchCond="searchMode" :min="0.1" :max="999.9" :precision="1" :step="0.1"/>
        <Numeric v-model="noiseLevel3" label="騒音値3[EPNdB]" prop="noise_level_3" :searchCond="searchMode" :min="0" :max="999" :step="1"/>
      </div>
    </template>
    <template v-else >
      <div class="el-form--inline">
        <Numeric v-model="weight1" label="重量1[t]" placeholder="0.1～999.9" prop="weight_1" :required="!searchMode" :searchCond="searchMode" :min="0.1" :max="999.9" :precision="1" :step="0.1"/>
        <Numeric v-model="noiseLevel1" label="騒音値1[EPNdB]" placeholder="0～999" prop="noise_level_1" :required="!searchMode" :searchCond="searchMode" :min="0" :max="999" :step="1"/>
      </div>
      <div class="el-form--inline">
        <Numeric v-model="weight2" label="重量2[t]" placeholder="0.1～999.9" prop="weight_2" :searchCond="searchMode" :min="0.1" :max="999.9" :precision="1" :step="0.1"/>
        <Numeric v-model="noiseLevel2" label="騒音値2[EPNdB]" placeholder="0～999" prop="noise_level_2" :searchCond="searchMode" :min="0" :max="999" :step="1"/>
      </div>
      <div class="el-form--inline">
        <Numeric v-model="weight3" label="重量3[t]" placeholder="0.1～999.9" prop="weight_3" :searchCond="searchMode" :min="0.1" :max="999.9" :precision="1" :step="0.1"/>
        <Numeric v-model="noiseLevel3" label="騒音値3[EPNdB]" placeholder="0～999" prop="noise_level_3" :searchCond="searchMode" :min="0" :max="999" :step="1"/>
      </div>
      <el-divider />
      <Remarks v-model="remarks" />
    </template>
  </el-form>
</template>

<script>
import RegistrationSymbol from '@/components/molecules/form/autocomplete/RegistrationSymbol.vue'
import OwnerCode from '@/components/molecules/form/autocomplete/OwnerCode.vue'
import DateTime from '@/components/molecules/form/date/DateTime.vue'
import DateTimeRange from '@/components/molecules/form/date/DateTimeRange.vue'
// import Date from '@/components/molecules/form/date/Date.vue'
// import DateRange from '@/components/molecules/form/date/DateRange.vue'
import ModelCode from '@/components/molecules/form/autocomplete/ModelCode.vue'
import AircraftType from '@/components/molecules/form/select/AircraftType.vue'
// import Weight from '@/components/molecules/form/number/Weight.vue'
// import NoiseLevel from '@/components/molecules/form/number/NoiseLevel.vue'
import Numeric from '@/components/molecules/form/number/Numeric.vue'
import Remarks from '@/components/molecules/form/textarea/Remarks.vue'
import AircraftAttribute from '@/components/molecules/form/select/AircraftAttribute.vue'
import Blank from '@/components/molecules/form/text/Blank.vue'

export default {
  components: {
    RegistrationSymbol,
    OwnerCode,
    DateTime,
    DateTimeRange,
    ModelCode,
    AircraftType,
    // Weight,
    // NoiseLevel,
    Numeric,
    Remarks,
    AircraftAttribute,
    Blank
  },
  model: {
    prop: 'model'
  },
  props: {
    model: Object,
    formMode: {
      type: String,
      default: 'search'
    },
    rules: Object,
    autocompleteRegistrationSymbolSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteOwnerCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteModelCodeSet: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {}
  },
  computed: {
    registrationSymbol: {
      get () {
        return this.model.registration_symbol
      },
      set (registrationSymbol) {
        const form = { ...this.model }
        form.registration_symbol = registrationSymbol
        this.$emit('input', form)
      }
    },
    ownerCode: {
      get () {
        return this.model.owner_code
      },
      set (ownerCode) {
        const form = { ...this.model }
        form.owner_code = ownerCode
        this.$emit('input', form)
      }
    },
    searchBaseDate: {
      get () {
        return this.model.search_base_date
      },
      set (searchBaseDate) {
        const form = { ...this.model }
        form.search_base_date = searchBaseDate
        this.$emit('input', form)
      }
    },
    startDate: {
      get () {
        return this.model.start_date
      },
      set (startDate) {
        const form = { ...this.model }
        form.start_date = startDate
        this.$emit('input', form)
      }
    },
    endDate: {
      get () {
        return this.model.end_date
      },
      set (endDate) {
        const form = { ...this.model }
        form.end_date = endDate
        this.$emit('input', form)
      }
    },
    modelCode: {
      get () {
        return this.model.model_code
      },
      set (modelCode) {
        const form = { ...this.model }
        form.model_code = modelCode
        this.$emit('input', form)
      }
    },
    aircraftType: {
      get () {
        return this.model.aircraft_type
      },
      set (aircraftType) {
        const form = { ...this.model }
        form.aircraft_type = aircraftType
        this.$emit('input', form)
      }
    },
    weight1: {
      get () {
        return this.model.weight_1
      },
      set (weight1) {
        const form = { ...this.model }
        form.weight_1 = weight1
        this.$emit('input', form)
      }
    },
    noiseLevel1: {
      get () {
        return this.model.noise_level_1
      },
      set (noiseLevel1) {
        const form = { ...this.model }
        form.noise_level_1 = noiseLevel1
        this.$emit('input', form)
      }
    },
    weight2: {
      get () {
        return this.model.weight_2
      },
      set (weight2) {
        const form = { ...this.model }
        form.weight_2 = weight2
        this.$emit('input', form)
      }
    },
    noiseLevel2: {
      get () {
        return this.model.noise_level_2
      },
      set (noiseLevel2) {
        const form = { ...this.model }
        form.noise_level_2 = noiseLevel2
        this.$emit('input', form)
      }
    },
    weight3: {
      get () {
        return this.model.weight_3
      },
      set (weight3) {
        const form = { ...this.model }
        form.weight_3 = weight3
        this.$emit('input', form)
      }
    },
    noiseLevel3: {
      get () {
        return this.model.noise_level_3
      },
      set (noiseLevel3) {
        const form = { ...this.model }
        form.noise_level_3 = noiseLevel3
        this.$emit('input', form)
      }
    },
    remarks: {
      get () {
        return this.model.remarks
      },
      set (remarks) {
        const form = { ...this.model }
        form.remarks = remarks
        this.$emit('input', form)
      }
    },
    aircraftAttribute: {
      get () {
        return this.model.aircraft_attribute
      },
      set (aircraftAttribute) {
        const form = { ...this.model }
        form.aircraft_attribute = aircraftAttribute
        this.$emit('input', form)
      }
    },
    updateDate: {
      get () {
        return this.model.updated_on
      },
      set (updateDate) {
        const form = { ...this.model }
        form.updated_on = updateDate
        this.$emit('input', form)
      }
    },
    searchMode: {
      get () {
        return this.formMode === 'search'
      }
    },
    editMode: {
      get () {
        return this.formMode === 'edit'
      }
    }
  },
  mounted () {
  },
  methods: {
    clearFields () {
      this.$refs.registrationSymbolForm.resetFields()
      if (!this.editMode) {
        this.model.search_base_date = undefined
        this.model.start_date = undefined
        this.model.end_date = undefined
        this.model.date_range = undefined
      }
    },
    validate () {
      return new Promise((resolve, reject) => {
        this.$refs.registrationSymbolForm.validate((valid) => {
          if (valid) {
            resolve(valid)
          } else {
            reject(new Error('validate error'))
          }
        })
      })
    }
  }
}
</script>

<style lang="scss">
// .registration-symbol-form {
//   ::v-deep .el-form-item__content .el-input__inner {
//     width: 12em;
//   }
// }
</style>
